import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Link } from 'gatsby'

const LinkButton = ({ text, route, newTab, isSecondary, isTertiary }) => {
  function renderContent() {
    return (
      <div className="button-container">
        <span>{text}</span>
      </div>
    )
  }

  if (newTab) {
    return (
      <a
        href={route}
        target="_blank"
        rel="noopener noreferrer"
        className={cx('primary-button', {
          '--secondary': isSecondary,
          '--tertiary': isTertiary,
        })}
      >
        {renderContent()}
      </a>
    )
  }

  return (
    <Link
      to={route}
      className={cx('primary-button', {
        '--secondary': isSecondary,
        '--tertiary': isTertiary,
      })}
    >
      {renderContent()}
    </Link>
  )
}

LinkButton.propTypes = {
  text: PropTypes.string,
  route: PropTypes.string,
  newTab: PropTypes.bool,
  isSecondary: PropTypes.bool,
  isTertiary: PropTypes.bool,
}

export default LinkButton
